import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import ButtonCell from "../../components/StaticDetailList/ButtonCell";
import EditableCell from "../../components/StaticDetailList/EditableCell";

import '@isceco/widget-library2/basic-elements/Popup/Popup'
import '@isceco/widget-library2/basic-elements/Button/Button'
import DateCell from "@isceco/widget-library2/basic-elements/List/cell/DateCell.js";
import EnergyCell from "../../components/StaticDetailList/EnergyCell";

export default class VerfuegungColumns {

  static getNeuColumns(previewCallback, versandCallback, anpassenCallback) {
    return [
      VerfuegungColumns.GP_COLUMN(),
      VerfuegungColumns.BERECHNETES_KONTINGENT_COLUMN(),
      VerfuegungColumns.ANGEPASSTES_KONTINGENT_COLUMN(anpassenCallback),
      VerfuegungColumns.VERSANDART_COLUMN(),
      VerfuegungColumns.VERSANDADRESSE_COLUMN(),
      previewCallback ? VerfuegungColumns.PREVIEW_COLUMN(previewCallback) : null,
      versandCallback ? VerfuegungColumns.VERSAND_COLUMN(versandCallback) : null
    ].filter(v => v)
  }

  static getPendentColumns(previewCallback, versandCallback, briefversandCallback) {
    return [
      VerfuegungColumns.GP_COLUMN(),
      VerfuegungColumns.STATUS_COLUMN(),
      VerfuegungColumns.VERSAND_DATUM_COLUMN(briefversandCallback),
      previewCallback ? VerfuegungColumns.PREVIEW_COLUMN(previewCallback) : null,
      versandCallback ? VerfuegungColumns.VERSAND_COLUMN(versandCallback) : null
    ].filter(v => v)
  }

  static GP_COLUMN() {
    return new StringColumn({
      weight: 2,
      key: 'gp',
      text: 'verfuegung.table.header.gp',
      sortable: true
    })
  }

  static BERECHNETES_KONTINGENT_COLUMN() {
    return new GenericColumn({
      key: 'berechneterWert',
      text: 'verfuegung.table.header.berechneterWert',
      sortable: true,
      cell: new EnergyCell()
    })
  }

  static ANGEPASSTES_KONTINGENT_COLUMN(anpassenCallback) {
    return new GenericColumn({
      key: 'angepassterWert',
      text: 'verfuegung.table.header.angepassterWert',
      sortable: true,
      cell: new EditableCell({
        editCallback: anpassenCallback,
        helpText: ({row}) => row.angepasstKommentar,
        cell: new EnergyCell()
      })
    })
  }

  static VERSANDART_COLUMN() {
    return new StringColumn({
      key: 'versandart',
      text: 'verfuegung.table.header.versandart',
      sortable: true,
      translate: true
    })
  }

  static VERSANDADRESSE_COLUMN() {
    return new StringColumn({
      weight: 2,
      key: 'versandadresse',
      text: 'verfuegung.table.header.versandadresse'
    })
  }

  static STATUS_COLUMN() {
    return new GenericColumn({
      weight: 2,
      key: 'status',
      text: 'verfuegung.table.header.status',
      cell: {
        render: (i18n, wert) => wert ? i18n.translate(`verfuegung.status.${wert.toLowerCase()}`) : null
      }
    })
  }

  static VERSAND_DATUM_COLUMN(briefversandCallback) {
    return new GenericColumn({
      key: 'versanddatum',
      text: 'verfuegung.table.header.versanddatum',
      sortable: true,
      cell: new EditableCell({
        editCallback: briefversandCallback,
        cell: new DateCell()
      })
    })
  }

  static PREVIEW_COLUMN(previewCallback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new ButtonCell({
        text: 'verfuegung.button.preview',
        callback: previewCallback
      })
    })
  }

  static VERSAND_COLUMN(versandCallback) {
    return new GenericColumn({
      weight: 0,
      align: 'right',
      cell: new ButtonCell({
        textCallback: row => row.elektronischerVersand ? 'verfuegung.button.versenden.single.elektronisch' : 'verfuegung.button.versenden.single.brief',
        variant: 'primary',
        callback: versandCallback,
        disabled: row => row.archivedOn
      })
    })
  }
}
